import { v4 as uuidv4 } from 'uuid';
import { useState } from 'react';
import { Button } from '@mui/material';
import { logErrorGrayLog } from './lib/ClientErrorGrayLogger';

// So I can use hooks in the error boundry
// Want to send to an endpoint to log
export const ErrorBoundaryMessage = (props) => {
    const [referenceGuid] = useState(uuidv4());
    const [isSent, setIsSent] = useState(false);

    if (props.error && !isSent)
    {
        const clientError = {
            referenceGuid: referenceGuid,
            clientError: props.error.toString(),
            clientStacktrace: props.errorInfo.componentStack,
            url: window?.location?.href
        };

        // Send to grayLog
        logErrorGrayLog(clientError);
        setIsSent(true);
    }

    const reload = () => {
        window.location.reload("Refresh")
    }

    return (
        <div>
            <h2>{"Something went wrong."}</h2>
            {"Trace ID:"} {referenceGuid}
            <Button
                onClick={reload}
                variant="contained"
                fullWidth
                sx={{ mt: 2, mb: 2 }}
            >
                Reload
            </Button>
        </div>
    );

}